import globals from './globals'

export const render = (moduleIndex) => {
    // Tabs Control active state
    var tabsLine = document.querySelector('.tabs-line'),
        tabs = document.querySelectorAll('.tabs-desktop .tabs-title a'),
        titleIcon = document.querySelector('.title-icon'),
        tabsContainer = document.querySelector('.tabs'),
        tabsTitle= document.querySelector('.title-toggler')

        // Move tabs Line To Active Tab Title
        tabs.forEach((obj, index) => { 
            if (index === 0) {
                tabsLine.style.left = (obj.offsetLeft + globals.getElementContentWidth(obj) - 150) + "px"
            } 
            obj.addEventListener('click', (e) => {
                e.preventDefault()
                tabsLine.style.left = (obj.offsetLeft + globals.getElementContentWidth(obj) - 150) + "px"
            })
        })


        // Title Icon Animations
        if (titleIcon.classList.contains('is-tooth')) {
            titleIcon.classList.add('animated', 'bounce', 'infinite')
        } else {
            titleIcon.classList.add('animated', 'rubberBand', 'infinite')
        }


        // Icon Animation Intersection Observers
        if ("IntersectionObserver" in window) {
            var icons = document.querySelectorAll('.tabs-content img')

            let svgObserver = new IntersectionObserver(function (entries, observer) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        // Star Blob
                        if (entry.target.classList.contains('stars-blob')) {
                            entry.target.classList.add('animated', 'pulse', 'infinite')
                        }
                        // Kid Flying
                        if (entry.target.classList.contains('kid-flying')) {
                            entry.target.classList.add('transitionIn')
                        }
                        // Stars Group
                        if (entry.target.classList.contains('stars-group')) {
                            entry.target.classList.add('animated', 'pulse', 'infinite')
                        }
                        // Shooting Star
                        if (entry.target.classList.contains('shooting-star')) {
                            entry.target.classList.add('flyInBottom')
                        }
                        
                    }

                })
            })
            icons.forEach((icon, index) => {
                svgObserver.observe(icon, {
                    threshold: 0.0,
                    rootMargin: '60%'
                })
            })
        }

}